import React from "react";
import MainDisplay from "./Main";

const HomePage = () => <MainDisplay />;

export default HomePage;
